import axios from "axios";
import React, { useEffect, useState } from "react";
import styles from "./styles.css";
import Select from "react-select";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Label,
} from "reactstrap";
import { URL_API } from "variable";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { IMAGE_URL } from "variable";

toast.configure();

function ModelEdit() {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
      [{ align: [] }],
      ["code-block"],
    ],
  };

  const formats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "align",
    "code-block",
  ];

  const id = useParams();
  const history = useHistory();

  const [name, setName] = useState();
  const [description, setDescription] = useState("");
  const [image, setImage] = useState();
  const [heroImage, setHeroImage] = useState();
  const [model, setModel] = useState();

  useEffect(() => {
    getModel();
    let token = localStorage.getItem("token");
  }, []);

  const onNameChange = (e) => {
    setName([e.target.value]);
  };

  const onDescChange = (e) => {
    setDescription([e.target.value]);
  };

  const onImageChange = (event) => {
    if (!event.target.files[0]) {
      return false;
    } else {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      setImage(files[0]);
    }
  };

  const getModel = () => {
    axios
      .get(URL_API + `auth/admin/modle/${id.id}/edit`)
      .then((response) => {
        console.log("Model edit", response.data.vehicle);
        if (response.data.status === 200) {
          setModel(response.data.vehicle);
          setName(response.data.vehicle.modle_name);
          setDescription(response.data.vehicle.description);
          setImage(response.data.vehicle.image);
        }
      });
  };

  
  const onSubmit = (event) => {
    event.preventDefault();

    let formData = new FormData();

    formData.append("modle_name", name);
    formData.append("image", image);
    formData.append("description", " ");
    // formData.append("description", description.replace(/<[^>]+>/g, ""));
    axios
      .post(URL_API + `auth/admin/modle/update-modle/${id.id}`, formData)
      .then((response) => {
        if (response.status == 200) {
          history.push(`/admin/maker/models/${model?.vehicle?.id}`);
          toast.success("Model Updated Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="content">
        <form onSubmit={(e) => onSubmit(e)}>
          <div className={`container-fluid`}>
            <div className={styles.HeroiImgBlogForm}>
              <div className={styles.paddingTopBottomBlogForm}>
                <h3 className={styles.HeroiImgTextBlogForm}>Update Model</h3>
              </div>
            </div>
            <br />
            <div className="container">
              <div className={`form ${styles.blogPostForm}`}>
                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Name
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    placeholder="modle name"
                    value={name}
                    onChange={(e) => onNameChange(e)}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="post-Images" className={styles.labelPostForm}>
                    Upload Image
                  </label>
                  <Input
                    id="image"
                    type="file"
                    name="image"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    onChange={(e) => onImageChange(e)}
                    
                  />
                </div>

                <div className="form-group">
                  <label
                    htmlFor="post-Images"
                    className={styles.labelPostForm}
                    style={{ paddingRight: "20px" }}
                  >
                    Current Image
                  </label>
                  <img
                    height="150px"
                    width="200px"
                    src={IMAGE_URL + model?.image}
                  />
                </div>
{/* 
                <ReactQuill
                  onChange={(value) => {
                    setDescription(value);
                  }}
                  value={description}
                  modules={modules}
                  formats={formats}
                  placeholder="Enter Maker Description"
                /> */}

                <br />
                <Input
                  type="submit"
                  name="submit"
                  className={`btn btn-danger ${styles.blogPostFormBtn}`}
                  value="Submit"
                />
              </div>
              <br />
              <br />
            </div>
          </div>
          {/* <BlogForm handleChange={handleChange} /> */}
        </form>
      </div>
    </>
  );
}

export default ModelEdit;
